import { useContext } from 'react'

import { JourneyContext, JourneyContextProps } from '@/contexts/journey'

interface UseReminderProps {
  reminderSet: JourneyContextProps['reminderSet']
  setReminderSet: JourneyContextProps['setReminderSet']
}

export const useReminder = (): UseReminderProps => {
  const { reminderSet, setReminderSet } = useContext(JourneyContext)

  return {
    reminderSet,
    setReminderSet
  }
}
